<template>
  <div>
      <section class="xlrclh">
          <img class="top-img" src="./../assets/imgs/135/base.png" alt="" />
          <div class="technological-process">
              <div class="rhtj mar-t2">
                  <img
                      class="top"
                      src="./../assets/imgs/xllh/rcgyysq_zcjj.png"
                      alt=""
                  />
                  <div class="content">
                    深入贯彻习近平总书记关于推动乡村人才振兴的重要指示精神，全面落实中央、省、市有关决策部署，着力壮大农业职业经理人队伍，强化乡村振兴人才支撑。
                  </div>
              </div>
              <div class="zccl" >
                  <img
                      class="top"
                      src="./../assets/imgs/135/title1.png"
                      alt=""
                  />
                  <div class="content" style="background-color: #fff;">
                    把正在从事或有意愿从事农业生产经营和社会化服务的人员全部纳入培育选拔范围。以镇（街道）为单位组织开展需求摸底，建立培育对象名录库，分年度制定培育计划，广泛选拔各类人才，发展壮大一支有文化、懂技术、善经营、会管理的农业职业经理人队伍。
                  </div>
              </div>
              <div class="zccl">
                  <img
                      class="top"
                      src="./../assets/imgs/135/title2.png"
                      alt=""
                  />
                  <div class="content">
                      <div class="des" style="margin-top: 0.26rem;">
                          <div >
                            （一）政策性农业保险补助
                          </div>
                      </div>
                      <div class="des" style="margin-top: 0.26rem;">
                          <div >
                            （二）鼓励参加养老保险
                          </div>
                      </div>
                      <div class="des" style="margin-top: 0.26rem;">
                          <div >
                            （三）实行分层分类培训
                          </div>
                      </div>
                      <div class="des" style="margin-top: 0.26rem;">
                          <div >
                            （四）开展科技帮扶行动
                          </div>
                      </div>
                      <div class="des" style="margin-top: 0.26rem;">
                          <div >
                            （五）强化金融服务供给
                          </div>
                      </div>
                      <div class="des" style="margin-top: 0.26rem;">
                          <div >
                            （六）健全服务体系
                          </div>
                      </div>
                      <div class="tips" @click="navDetail">
                        （具体参见《成都市深化农业职业经理人队伍建设的十条措施（试行）》）
                      </div>
                  </div>
              </div>

              <div class="gmlc">
                  <img
                      class="top"
                      src="./../assets/imgs/135/title3.png"
                      alt=""
                  />
                  <div class="content">
                      <div class="des mar-t3">
                          <div class="line-item">
                              <div class="line"></div>
                              <div class="line-top">
                                  <div class="line-num">1</div>
                                  <div class="line-title">自主申报</div>
                              </div>
                              <div class="line-content">
                                通过农业职业经理人培训（直评除外）的人员，根据区（市）县农业职业经理人评价管理机构的统一安排，对照评价条件，自愿提出申请，并提交相关材料。
                              </div>
                          </div>
                          <div class="line-item">
                              <div class="line"></div>
                              <div class="line-top">
                                  <div class="line-num">2</div>
                                  <div class="line-title">评价推荐</div>
                              </div>
                              <div class="line-content">
                                区（市）县农业职业经理人评价管理机构开展初级、中级（含直评）农业职业经理人评价，并向市农业农村局推荐高级（含直评）评价候选人，市农业职业经理人评价委员会负责开展高级（含直评）农业职业经理人的评价。
                              </div>
                          </div>

                          <div class="line-item">
                              <div class="line-top">
                                  <div class="line" style="height: 140%;"></div>
                                  <div class="line-num">3</div>
                                  <div class="line-title" style="text-wrap: nowrap;">公示颁证</div>
                              </div>
                              <div class="line-content">
                                区（市）县农业职业经理人评价管理机构和市评价委员会将评价的初、中和高级农业职业经理人分别在区（市）县农业农村局官网和市农业农村局官网公示，公示5个工作日无异议后，公布评价结果，并颁发相应等级的农业职业经理人证书。
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="company-box">
                <div class="content">
                  <img class="title-img" src="./../assets/imgs/135/tel.png" alt="">
                  <div class="item-title-box">
                    <div class="item-title-company"><span>责任单位</span></div>
                    <div class="item-title-tel"><span>政策咨询电话</span></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">成都东部新区农业农村局</div>
                    <div class="item-tel"><a href="tel:028-81339869">028-81339869</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">天府新区统筹城乡局</div>
                    <div class="item-tel"><a href="tel:028-68772997">028-68772997</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">龙泉驿区农业农村局</div>
                    <div class="item-tel"><a href="tel:028-84837156">028-84837156</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">青白江农业农村局</div>
                    <div class="item-tel"><a href="tel:028-60304030">028-60304030</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">新都区农业农村局</div>
                    <div class="item-tel"><a href="tel:028-83048011">028-83048011</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">温江区农业农村局</div>
                    <div class="item-tel"><a href="tel:028-82712707">028-82712707</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">双流区农业农村局</div>
                    <div class="item-tel"><a href="tel:028-85717716">028-85717716</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">郫都区农业农村局</div>
                    <div class="item-tel"><a href="tel:028-86550519">028-86550519</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">简阳市农业农村局</div>
                    <div class="item-tel"><a href="tel:028-27028168">028-27555679</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">都江堰市农业农村局</div>
                    <div class="item-tel"><a href="tel:028-87119859">028-87119859</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">彭州市农业农村局</div>
                    <div class="item-tel"><a href="tel:028-83871054">028-83891951</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">邛崃市农业农村局</div>
                    <div class="item-tel"><a href="tel:028-88767810">028-88767810</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">崇州市农业农村局</div>
                    <div class="item-tel"><a href="tel:028-82380320">028-82380320</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">金堂县农业农村局</div>
                    <div class="item-tel"><a href="tel:028-84982519">028-84982519</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">新津区农业农村局</div>
                    <div class="item-tel"><a href="tel:028-82516563">028-82516563</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">大邑县农业农村局</div>
                    <div class="item-tel"><a href="tel:028-88289496">028-88289496</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">蒲江县农业农村局</div>
                    <div class="item-tel"><a href="tel:028-63968108">028-63968108</a></div>
                  </div>
                </div>
              </div>
          </div>
      </section>
      <!-- <call phone="028-83221725"></call> -->
  </div>
</template>

<script>
import call from "../components/call.vue";
export default {
  data() {
      return {};
  },

  components: {
      call,
  },

  mounted() {},

  methods: {
    navDetail() {
      this.$router.push('/136')
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
  background-color: $base-back;
  padding-top: 0.3rem;

  .top-img {
      width: 7.26rem;
      height: 5.6rem;
  }

  .technological-process {
      transform: translateY(-2.6rem);

      .rhtj {
          position: relative;

          .top {
              width: 6.86rem;
              height: 1.12rem;
          }

          .content {
              width: 6.85rem;
              margin: -0.45rem auto 0;
              padding: 0.33rem;
              box-sizing: border-box;
              border-radius: 0rem 0rem 0.26rem 0.26rem;
              background: #ffffff;
              font-size: 0.26rem;
              color: #4e4e4e;
              text-align: left;
              position: relative;
              font-weight: 500;
              line-height: 0.44rem;
          }
      }

      .zccl {
          position: relative;
          margin-top: 0.22rem;

          .top {
              width: 7.03rem;
              height: 1.37rem;
              margin-left: -0.18rem;
          }

          .content {
              width: 6.85rem;
              background: #e8eeff;
              margin: -0.45rem auto 0;
              padding: 0.33rem;
              box-sizing: border-box;
              border-radius: 0rem 0rem 0.26rem 0.26rem;
              padding-top: 0.28rem;
              font-size: 0.26rem;
              font-weight: 500;
              text-align: left;
              color: #4e4e4e;
              line-height: 0.44rem;

              .circle-box {
                font-size: 0.34rem;
                color: #333;
                font-weight: bold;
                padding-top: 0.3rem;
                text-align: left;
                position: relative;
                .circle {
                  width: 0.28rem;
                  height: 0.28rem;
                  border: 0.06rem solid #FF6D60;
                  border-radius: 50%;
                  flex-shrink: 0;
                  box-sizing: border-box;
                  position: absolute;
                  left: 0;
                  top: 0.35rem;
                  display: inline-block;
                }
                .circle-txt {
                  text-indent: 0.6em;
                }
              }

              .des {
                  color: #4e4e4e;
                  text-align: left;
                  background: #ffffff;
                  border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                  padding: 0.35rem 0.23rem 0.3rem;
                  margin-top: 0.8rem;
                  position: relative;
                  text-align: left;

                  .title {
                      position: absolute;
                      top: -0.5rem;
                      left: 50%;
                      transform: translateX(-50%);
                      width: 4.86rem;
                      height: 0.67rem;
                      line-height: 0.67rem;
                      display: flex;
                      justify-content: center;
                      align-content: center;
                      font-size: 0.32rem;
                      font-weight: bold;
                      color: #ffffff;
                      border-radius: 1rem;
                      background-color: #739bfe;
                  }
              }
              .tips {
                padding-top: 0.34rem;
                color: #2350BF;
                font-size: 0.26rem;
                font-weight: bold;
              }
          }
      }

      .gmlc {
          position: relative;
          margin-top: 0.22rem;

          .top {
              width: 7.03rem;
              height: 1.37rem;
              margin-left: -0.18rem;
          }

          .content {
              width: 6.86rem;
              background: #e8eeff;
              margin: -0.55rem auto;
              padding: 0 0.33rem 0.35rem 0.36rem;
              box-sizing: border-box;
              border-radius: 0rem 0rem 0.26rem 0.26rem;

              .circle-box {
                font-size: 0.34rem;
                color: #333;
                font-weight: bold;
                padding-top: 0.5rem;
                text-align: left;
                position: relative;
                .circle {
                  width: 0.28rem;
                  height: 0.28rem;
                  border: 0.06rem solid #FF6D60;
                  border-radius: 50%;
                  flex-shrink: 0;
                  box-sizing: border-box;
                  position: absolute;
                  left: 0;
                  top: 0.62rem;
                  display: inline-block;
                }
                .circle-txt {
                  text-indent: 1.1em;
                }
              }

              .title {
                  font-size: 0.36rem;
                  font-weight: bold;
                  color: #333333;
                  text-align: left;
                  line-height: 0.5rem;
              }

              .des {
                  color: #4e4e4e;
                  text-align: left;
                  background: #ffffff;
                  border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                  padding: 0.3rem 0.23rem;
                  font-size: 0.26rem;
                  font-weight: 500;
                  color: #4e4e4e;
                  line-height: 0.44rem;

                  .line-item {
                      font-size: 0.26rem;
                      position: relative;
                      z-index: 3;

                      .line {
                          position: absolute;
                          width: 0.02rem;
                          height: 130%;
                          border-left: 0.02rem dashed #739bfe;
                          left: 0.2rem;
                          z-index: 0;
                          //   background-color: #739bfe;
                      }

                      .line-title {
                          font-size: 0.3rem;
                          font-weight: bold;
                          color: #3d5aa3;
                      }

                      .line-top {
                          display: flex;
                          width: 4.4rem;
                          height: 0.55rem;
                          background-image: url(../assets/imgs/25/label.png);
                          background-size: 100% 100%;
                          z-index: 99;
                          display: flex;
                          align-items: center;
                          box-sizing: border-box;
                          padding-left: 0.1rem;

                          .line-num {
                              width: 0.44rem;
                              height: 0.44rem;
                              background: #fff;
                              color: #3d5aa3;
                              display: inline-flex;
                              border-radius: 50%;
                              justify-content: center;
                              align-items: center;
                              margin-right: 0.18rem;
                              position: relative;
                              z-index: 3;
                              display: flex;
                              align-items: center;
                              justify-content: center;
                              font-size: 0.28rem;
                              font-weight: bold;
                          }
                      }

                      .line-content {
                          //   border-left: 0.02rem dashed #739bfe;
                          padding-bottom: 0.32rem;
                          margin-left: 0.2rem;
                          padding-left: 0.32rem;
                          padding-top: 0.15rem;
                          word-break: break-all;
                          line-height: 0.44rem;
                      }
                  }
              }
          }
      }

      .company-box {
        margin-top: 0.75rem;
        padding: 0 0.33rem;
        color: #4E4E4E;
        .content {
          width: 6.86rem;
          box-sizing: border-box;
          background-color: #fff;
          border-radius: 0.2rem;
          margin: 0 auto;
          margin-top: 0.22rem;
          padding: 0 0.2rem;
          padding-bottom: 0.55rem;
          .title-img {
            width: 5.31rem;
            height: 1.33rem;
            margin-top: 0.24rem;
          }
          .item-title-box {
            width: 100%;
            display: flex;
            align-items: center;
            margin-bottom: 0.3rem;
            .item-title-company {
              width: 3.95rem;
              display: flex;
              justify-content: center;
              span {
                display: inline-block;
                width: 1.37rem;
                height: 0.43rem;
                text-align: center;
                line-height: 0.43rem;
                color: #fff;
                background-color: #6DA8FF;
                font-size: 0.29rem;
              }
            }
            .item-title-tel {
              width: 2.5rem;
              display: flex;
              justify-content: center;
              span {
                display: inline-block;
                width: 2.21rem;
                height: 0.43rem;
                text-align: center;
                line-height: 0.43rem;
                color: #fff;
                background-color: #6DA8FF;
                font-size: 0.29rem;
              }
            }
          }
          .item-box {
            display: flex;
            align-items: center;
            border-top: 1px solid #CBC8C8;
            font-size: 0.26rem;
            height: 0.55rem;
            font-weight: bold;
            .item-company {
              width: 3.95rem;
              height: 100%;
              padding-left: 0.22rem;
              text-align: left;
              line-height: 0.55rem;
              border-right: 1px solid #CBC8C8;
            }
            .item-tel {
              width: 2.5rem;
              height: 100%;
              text-align: left;
              line-height: 0.55rem;
              padding-left: 0.22rem;
            }
          }
          .item-box:last-child {
            border-bottom: 1px solid #CBC8C8;
          }
        }
      }

      .codes {
          margin: 0 auto;
          margin-top: 0.25rem;
          width: 6.85rem;
          background: #fff;
          padding: 0.3rem;
          box-sizing: border-box;
          border-radius: 0.26rem;
          padding-top: 0.28rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .info {
            width: 100%;
            height: 100%;
          }
      }
  }
}
</style>
